import { Post, User } from './type';

const fetchUser = (username: string): Promise<User> => {
  return fetchData<User>(`${getBaseUrl()}/${username}/profile`);
};

const fetchPosts = (
  username: string,
  lastPostDate?: string,
): Promise<Post[]> => {
  let url = `${getBaseUrl()}/${username}/posts`;
  if (lastPostDate) {
    url += `?until=${lastPostDate}`;
  }
  return fetchData<Post[]>(url);
};

const clickPost = (username: string, p: Post): Promise<any> => {
  const createdISOStr = new Date(p.created).toISOString();
  return fetchData<any>(
    `${getBaseUrl()}/${username}/click/${p.id}?created=${createdISOStr}`,
  );
};

async function fetchData<T>(url: string): Promise<T> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  return (await response.json()) as Promise<T>;
}

function getBaseUrl(): string {
  return `/api/${window.TA.networkName}`;
}

export const API = {
  fetchPosts,
  fetchUser,
  clickPost,
};
